import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/img/common/portrait.jpg';
const _hoisted_1 = {
  class: "portrait-container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "portrait-img",
  src: _imports_0
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "download-text"
}, "3Q.APP", -1);
const _hoisted_4 = {
  class: "download-btn"
};
const _hoisted_5 = {
  class: "landscape-container"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
import { ref, provide, onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useEventListener } from '@vant/use';
import { usePlatform, useFullScreen, useAudio, useHelpTool } from "@/hooks";
import { useSettingsStore } from '@/store';
import { Local } from '@/assets/lang/index';
import FullScreenTip from '@/components/Common/FullScreenTip';
import MyToast from '@/plugins/component/MyToast';
import MyDialog from '@/plugins/component/MyDialog';
export default {
  __name: 'App',
  setup(__props) {
    const themeVars = {
      primaryColor: '#4E62E4',
      // passwordInputHeight: '45px',
      fieldPlaceholderTextColor: '#C1C1D6',
      tabbarHeight: '11.63vmin',
      emptyImageSize: '13.95vmin',
      buttonDisabledOpacity: '1'
    };
    const Platform = usePlatform();
    const {
      fullScreen
    } = useFullScreen();
    const {
      playAudio
    } = useAudio();
    const {
      openBrowser
    } = useHelpTool();
    const settingsStore = useSettingsStore();
    const {
      downloadPage
    } = storeToRefs(settingsStore);
    const registerCode = ref('');
    const showDownload = ref(false);
    const showGestureTip = ref(false);
    const hideCover = ref(false);
    provide('hideCover', hideCover);
    provide('myToast', MyToast);
    provide('myDialog', MyDialog);
    onMounted(() => {
      const search = window.location.search.split('?')[1];
      const urlString = search ? search.split('&') : [];
      const urlParam = {};
      for (var i = 0; i < urlString.length; i++) {
        const _param = urlString[i].split('=');
        urlParam[_param[0]] = _param[1];
      }
      registerCode.value = urlParam.code;
      let lang = navigator.browserLanguage || navigator.language;
      let langList = ['en-US', 'vi-VN'];
      if (langList.indexOf(lang) < 0) {
        lang = langList[0];
      }
      Local(lang);
      settingsStore.initDeviceInfo();
      settingsStore.fetchConfig();
      settingsStore.checkAppVersion();
      if (Platform.isIOS) {
        showGestureTip.value = true;
      }
      showDownload.value = window.$bridge || Platform.isIOS ? false : true;
    });
    useEventListener('click', () => {
      // 进入页面 第一次点击之后 音乐自动播放
      playAudio('bgm');
      if (Platform.isAndroid) {
        fullScreen(() => {
          showGestureTip.value = true;
        });
      }
    }, {
      target: document.body
    });
    const openDownloadApp = () => {
      let downloadUrl = downloadPage.value;
      if (registerCode.value) {
        if (downloadPage.value.indexOf('?') < 0) {
          downloadUrl = `${downloadPage.value}?code=${registerCode.value}`;
        } else {
          downloadUrl = `${downloadPage.value}&code=${registerCode.value}`;
        }
      }
      openBrowser(downloadUrl);
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_config_provider, {
        "theme-vars": themeVars
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, showDownload.value ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "download-banner flex",
          onClick: _cache[0] || (_cache[0] = $event => openDownloadApp())
        }, [_createVNode(_component_van_image, {
          class: "logo-img",
          src: require('@/assets/img/common/logo.png')
        }, null, 8, ["src"]), _hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('actionBtn.download')), 1)])), [[_directive_audio]]) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_view), showGestureTip.value ? (_openBlock(), _createBlock(_unref(FullScreenTip), {
          key: 0
        })) : _createCommentVNode("", true)])]),
        _: 1
      }), _createElementVNode("audio", {
        id: "bgm",
        src: require('@/assets/audio/bgm.mp3'),
        loop: ""
      }, null, 8, _hoisted_6), _createElementVNode("audio", {
        id: "clickSound",
        src: require('@/assets/audio/click-btn.wav')
      }, null, 8, _hoisted_7), _createElementVNode("audio", {
        id: "closeSound",
        src: require('@/assets/audio/close.wav')
      }, null, 8, _hoisted_8), _createElementVNode("audio", {
        id: "openSound",
        src: require('@/assets/audio/open-treasure.mp3')
      }, null, 8, _hoisted_9), _createElementVNode("audio", {
        id: "rollSound",
        src: require('@/assets/audio/roll-wheel.wav')
      }, null, 8, _hoisted_10)], 64);
    };
  }
};